import { wglcsApiService } from "../services/WglcsApiService";
import { CompanyType } from "../models/CompanyType";
import moment from "moment";
import {
    QcOperationTypeChecks,
    RoleInterface,
    HostingEnvironment,
    ChatPanelTypes,
    MonitoringPanelTypes,
    Templates,
    ChatMessageModel,
    ChatRegions,
    LoginResponse,
    ISpyResponseModel,
} from "../models/index";
import { Interfaces } from "../constants/Interfaces";
import { cookieService } from "../services/CookieService";
import {
    zipCodeRegex,
    emailRegex,
    phoneRegex,
    checkMaskingTypeEmail,
    checkMaskingTypePhone,
    isValidPhonenumber,
    getTime,
    getTimeForPreviousChat,
} from "../constants/urlChecker ";
import { DetectEnvironment } from "../EnvironmentSettings";
import { logger } from "../services/Logger";
import { t } from "i18next";
import { sessionStorageService } from "../services/SessionStorageService";

interface Industry {
  name: string;
  code: string;
}

class Utils {
    get GetTimeStampFormat() {
        return "YYYY-MM-DD hh:mm:ss";
    }

    get ServerTimeStampFormat() {
        return "YYYY-MM-DDThh:mm:ss.SSS";
    }

    getIndustries = (): Industry[] => {
        return [
                { name: "Autos", code: "AT" },
                { name: "Client Demo Domains", code: "CDD" },
                { name: "DEP Autos", code: "DPA" },
                { name: "DEP Autos.", code: "DEA" },
                { name: "Education", code: "EDU" },
                { name: "Foreign Language Autos", code: "FLA" },
                { name: "Foreign Language Education", code: "FLE" },
                { name: "Foreign Language Law", code: "FLL" },
                { name: "Foreign Language Others", code: "FLO" },
                { name: "Facebook Fan Pages", code: "FFP" },
                { name: "Healthcare", code: "HLC" },
                { name: "Instagram Linked Pages", code: "ILP" },
                { name: "LA Autos", code: "LAA" },
                { name: "Law", code: "LAW" },
                { name: "Others", code: "OTH" },
                { name: "Others Pool A", code: "OPA" },
                { name: "Others Pool B", code: "OPB" },
                { name: "Others Pool C", code: "OPC" },
                { name: "Power sports/ Power Equipment", code: "PPE" },
                { name: "Real Estate", code: "RE" },
                { name: "Software Client", code: "SWC" },
                { name: "Skin and Beauty", code: "SAB" },
                { name: "Support Solutions", code: "SPS" },
                { name: "Test Domains", code: "TD" },
        ];
    };

    getPanelName = () => {
        if(this.isOperaterScreenActive()){
            return "OP"
        }else if(this.isMonitoringPanelScreenActive()){
            return "6er"
        }else if(this.isLoggedInResourcesChatScreenActive()){
            return "Logged-in-resource-chat-window"
        }else if(this.isHybridScreenActive()){
            return "HybridChat"
        }else if(this.isTestingScreenActive()){
            return "Testing-module"
        }else if(this.isLoggedInResourcesScreenActive()){
            return "Logged-in-resources"
        }else{return}
    }

    convertServerDateToLocal = (date: Date | string): string => {
        return moment.utc(date, "YYYY-MM-DDThh:mm:ss.SSS").local().format("MM/DD/YYYY hh:mm:ss A");
    };

    isThirdPartyUrl = (message: string): boolean => {
        if (message == undefined && message == null) {
            return false
        }

        var regEx =
            /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/gim;

        var res = message.match(regEx);

        return res != null && res.length > 0;
    };

    isSameDomain(currentText, domainName) {
        if (this.isDomainBased(currentText)) {
            try {

                const normalizeURL = (url) => {
                    return new URL(url.startsWith("http") ? url : `https://${url}`).hostname.replace(/^www\./, "");
                };

                const res = normalizeURL(currentText) !== normalizeURL(domainName);


                return res
            } catch (error) {
                return false;
            }
        } else {
            return false
        }
    }

    isDomainBased(url) {
        try {
            const hostname = new URL(url.startsWith("http") ? url : `https://${url}`).hostname;

            const res = hostname.includes(".");

            return res
        } catch (error) {
            return false;
        }
    }

    getDomainFromString(input) {
        try {
            if (!input.startsWith("http://") && !input.startsWith("https://")) {
                input = "https://" + input;
            }

            let hostname = new URL(input).hostname;

            if (hostname.startsWith("www.")) {
                hostname = hostname.substring(4);
            }

            return hostname;
        } catch (error) {
            console.error("Invalid input:", input);
            return null;
        }
    }

    GenerateRandomCode = () => {
        const randomCode = Math.floor(1000 + Math.random() * 9000);
        return randomCode;
    };

    generateRandomId = () => {
        const timestamp = new Date().getTime(); // Get current timestamp
        const randomString = Math.random().toString(36).substring(2, 10); // Generate random string
        return timestamp + "-" + randomString; // Combine timestamp and random string
    };

    checkNetAndServersStatus = (chatType: string): boolean => {
        try {
            const isOnline = localStorage.getItem("internetConnectivity") === "true";
            if (!isOnline) return false;
            const isSignalRConnected = sessionStorageService.getItem("SignalRConnectionStatus") === "connected";
            const isOpenfireConnected = sessionStorageService.getItem("OpenFireConnectionStatus") === "Connected";

            if (chatType === "Chat") {
                return isOpenfireConnected;
            } else {
                return isSignalRConnected;
            }
        } catch (error) {
            console.error("Error checking network and server statuses:", error);
            return false;
        }
    };

    matchLastTwoObjects = (arr, key, text) => {
        let isLastSysmtemMsg = false
        if (!Array.isArray(arr) || arr.length < 2) return false;

        try {

            const [lastElement] = arr.slice(-1)

            if (this.isSystemMessage(lastElement[key])) {
                isLastSysmtemMsg = true
            }

            const [thirdLast, secondLast, last] = isLastSysmtemMsg ? arr.slice(-4, -1) : arr.slice(-3);
            const getValue = (obj, key) =>
                (typeof obj === 'object' && obj !== null) ? obj[key] : undefined;

            const isthirdLastSent = getValue(thirdLast, 'IsSent') === true;
            const isSecondLastSent = getValue(secondLast, 'IsSent') === true;
            const isLastSent = getValue(last, 'IsSent') === true;

            const thirdLastValue = getValue(thirdLast, key);
            const secondLastValue = getValue(secondLast, key);
            const lastValue = getValue(last, key);

            if (isthirdLastSent && isSecondLastSent && isLastSent) {
                return thirdLastValue === text.trim() && secondLastValue === text.trim() && lastValue === text.trim();
            }

            if (secondLastValue === "[destroy room]" || lastValue === "[destroy room]" || secondLastValue === "[DND]" || lastValue === "[DND]") {
                return true;
            }

            if (secondLastValue === "[DND]" || lastValue === "[DND]") {
                return true;
            }

            return false;
        } catch (error) {
            console.error("Error comparing values:", error);
            return false;
        }
    }


    getLocalTimeToGMT = (difference, _selectedTime) => {
        const selectedTime = _selectedTime;
        const timeDifference = difference; // Example: "+05:00:00" or "-05:00:00"

        const timeDifferenceParts = timeDifference.match(/([-+]?\d+):(\d+):(\d+)/);
        if (!timeDifferenceParts) {
            return;
        }

        const isNegativeDifference = timeDifferenceParts[1][0] === "-";
        const offsetHours = parseInt(timeDifferenceParts[1].slice(1));
        const offsetMinutes = parseInt(timeDifferenceParts[2]);
        const offsetSeconds = parseInt(timeDifferenceParts[3]);
        const timezoneOffsetMs = (offsetHours * 3600 + offsetMinutes * 60 + offsetSeconds) * 1000;

        var adjustedTime;
        var time = new Date(selectedTime);
        if (isNegativeDifference) {
            adjustedTime = new Date(time.getTime() + timezoneOffsetMs);
        } else {
            adjustedTime = new Date(time.getTime() - timezoneOffsetMs);
        }

        if (adjustedTime.getDate() !== time.getDate()) {
            adjustedTime = new Date(adjustedTime.getTime() + (adjustedTime.getTimezoneOffset() - time.getTimezoneOffset()) * 60000);
        }

        return adjustedTime.toString();
    };

    getGMTToLocalTime = (difference, _selectedTime) => {
        const selectedTime = _selectedTime;
        const timeDifference = difference; // Example: "+05:00:00" or "-05:00:00"

        const timeDifferenceParts = timeDifference.match(/([-+]?\d+):(\d+):(\d+)/);
        if (!timeDifferenceParts) {
            return;
        }

        const isNegativeDifference = timeDifferenceParts[1][0] === "-";
        const offsetHours = parseInt(timeDifferenceParts[1].slice(1));
        const offsetMinutes = parseInt(timeDifferenceParts[2]);
        const offsetSeconds = parseInt(timeDifferenceParts[3]);

        const timezoneOffsetMs = (offsetHours * 3600 + offsetMinutes * 60 + offsetSeconds) * 1000;

        var adjustedTime;
        var time = new Date(selectedTime);
        if (!isNegativeDifference) {
            adjustedTime = new Date(time.getTime() + timezoneOffsetMs);
        } else {
            adjustedTime = new Date(time.getTime() - timezoneOffsetMs);
        }

        if (adjustedTime.getDate() !== time.getDate()) {
            adjustedTime = new Date(adjustedTime.getTime() + (adjustedTime.getTimezoneOffset() - time.getTimezoneOffset()) * 60000);
        }

        return adjustedTime.toString();
    };
    convertTimeFormat = (startTime) => {
        let dateStr = startTime;

        let date = new Date(dateStr);

        let timeZoneOffset = date.getTimezoneOffset() * 60000; // offset in milliseconds
        let utcDate = new Date(date.getTime() - timeZoneOffset);

        let year = utcDate.getUTCFullYear();
        let month = String(utcDate.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-indexed
        let day = String(utcDate.getUTCDate()).padStart(2, "0");
        let hours = String(utcDate.getUTCHours()).padStart(2, "0");
        let minutes = String(utcDate.getUTCMinutes()).padStart(2, "0");
        let seconds = String(utcDate.getUTCSeconds()).padStart(2, "0");
        let milliseconds = String(utcDate.getUTCMilliseconds()).padStart(3, "0");

        let formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
        return formattedDate;
    };

    resourcePoolCols = () => {
        const columns = [
            { field: "userName", header: t("resourcesPoolTable.Username"), isChecked: true },
            { field: "roleName", header: t("resourcesPoolTable.Role Name"), isChecked: true },
            { field: "companyName", header: t("resourcesPoolTable.Company"), isChecked: true },
            { field: "languageName", header: t("resourcesPoolTable.Language"), isChecked: true },
            { field: "employeeEmail", header: t("resourcesPoolTable.Email"), isChecked: true },
            { field: "status", header: t("resourcesPoolTable.Status"), isChecked: true },
            { field: "alottedBreak", header: t("resourcesPoolTable.Alotted Break"), isChecked: true },
            { field: "companyId", header: t("resourcesPoolTable.Company Id"), isChecked: true },
            { field: "employeeFname", header: t("resourcesPoolTable.First Name"), isChecked: true },
            { field: "employeeLname", header: t("resourcesPoolTable.Last Name"), isChecked: true },
            { field: "employeePhone", header: t("resourcesPoolTable.PhoneNo"), isChecked: true },
            { field: "roleId", header: t("resourcesPoolTable.Role Id"), isChecked: true },
            { field: "userId", header: t("resourcesPoolTable.User Id"), isChecked: true },
            { field: "userNoOfChats", header: t("resourcesPoolTable.UserChats"), isChecked: true },
            { field: "Actions", header: t("ChatTranscriptComponent.Actions"), isChecked: true },
        ];
        return columns;
    };

    chatLogCols = () => {
        const columns = [
            { field: "visitorName", header: t("ChatTranscriptComponent.Visitor"), isChecked: true },
            { field: "userName", header: t("UnsentChat.Name"), isChecked: true },
            { field: "domainName", header: t("ChatTranscriptComponent.Website"), isChecked: true },
            // { field: "chatStartTime", header: t("ChatTranscriptComponent.Start Time"), isChecked: true },
            { field: "filterChatStartTime", header: t("ChatTranscriptComponent.Start Time"), isChecked: true },
            { field: "filterChatEndTime", header: t("ChatTranscriptComponent.End Time"), isChecked: true },
            // { field: "chatEndTime", header: t("ChatTranscriptComponent.End Time"), isChecked: true },
            { field: "emailStatus", header: t("ChatTranscriptComponent.Email Status"), isChecked: true },
            { field: "industry", header: t("ChatTranscriptComponent.Industry"), isChecked: true },
            { field: "emailDate", header: t("Chat Logs.Email Date"), isChecked: true },
            { field: "departmentName", header: t("Chat Logs.Department"), isChecked: true },
            { field: "checked", header: t("Chat Logs.Checked"), isChecked: true },
            { field: "checkedBy", header: t("Chat Logs.Checked-By"), isChecked: true },
            { field: "howManyTimesCheched", header: "How Many Time..", isChecked: true },
            { field: "device", header: t("LiveInfoCard.Device"), isChecked: false },
            { field: "chatId", header: t("Chat Logs.ChatId"), isChecked: false },
            { field: "chatType", header: t("Chat Logs.Chat-Type"), isChecked: true },
            { field: "Actions", header: t("ChatTranscriptComponent.Actions"), isChecked: true },
        ];
        return columns;
    };

    chatTranscriptCols = () => {
        const columns = [
            { field: "visitorName", header: t("ChatTranscriptComponent.Visitor"), isChecked: true },
            { field: "userName", header: t("ChatTranscriptComponent.Agent"), isChecked: true },
            { field: "domainName", header: t("ChatTranscriptComponent.Website"), isChecked: true },
            // { field: "chatStartTime", header: t("ChatTranscriptComponent.Start Time"), isChecked: true },
            { field: "filterChatStartTime", header: t("ChatTranscriptComponent.Start Time"), isChecked: true },
            { field: "filetrChatEndTime", header: t("ChatTranscriptComponent.End Time"), isChecked: true },
            // { field: "chatEndTime", header: t("ChatTranscriptComponent.End Time"), isChecked: true },
            { field: "emailStatus", header: t("ChatTranscriptComponent.Email Status"), isChecked: true },
            { field: "emailDate", header: t("ChatTranscriptComponent.Date"), isChecked: true },
            { field: "departmentName", header: t("ChatTranscriptComponent.Dpt. Name"), isChecked: true },
            { field: "qcAgents", header: t("ChatTranscriptComponent.QC Agents"), isChecked: true },
            { field: "csaAgent", header: t("ChatTranscriptComponent.CSA Agent"), isChecked: true },
            { field: "chatOrigin", header: t("ChatTranscriptComponent.Chat Origin"), isChecked: true },
            { field: "chatId", header: t("ChatTranscriptComponent.Chat Id"), isChecked: true },
            { field: "userId", header: t("ChatTranscriptComponent.User Id"), isChecked: true },
            { field: "visitorId", header: t("ChatTranscriptComponent.Visitor Id"), isChecked: true },
            { field: "websiteId", header: t("ChatTranscriptComponent.Website Id"), isChecked: true },
            { field: "industry", header: t("ChatTranscriptComponent.Industry"), isChecked: true },
            { field: "Actions", header: t("ChatTranscriptComponent.Actions"), isChecked: true },
        ];
        return columns;
    }

    adjustTimeWithLocalTimeZone = (datetimeStr) => {
        const format = "YYYY-MM-DD - HH:mm:ss";
        const originalTime = moment(datetimeStr, format);
        const newTime = originalTime.add(5, "hours").format(format);
        return newTime;
    };


    StripStartAndTrailingSlashes = (str: string) => {
        var startIndex = str.startsWith("/") ? 1 : 0;
        var endsIndex = str.endsWith("/") ? -1 : str.length;

        return str.slice(startIndex, endsIndex);
    };

    GetCompanyType = async (companyId: string): Promise<CompanyType> => {
        if (utils.isLiveAdminsCompany(companyId)) {
            var RoleInterface = (await wglcsApiService.getroleinterfaces()).data!.data;
            let interfaceResponse = RoleInterface.some((el) => el.interfaceName === Interfaces.ChatTranscriptsWithQC);
            if (interfaceResponse) {
                return CompanyType.LiveAdmins1;
            } else {
                return CompanyType.LiveAdmins2;
            }
        } else if (utils.isEaglyHillsCompany(companyId)) {
            return CompanyType.EaglyHills;
        } else {
            return CompanyType.DEP;
        }

        // return CompanyType.Unknown;
    };

    convertFirstCapital = (value: string) => {
        if (value != "" && value != null && value != undefined) {
            return value?.split(' ')?.map(word => word.charAt(0).toUpperCase() + word.slice(1))?.join(' ')
        }
        return value
    }

    isLiveAdminsCompany = (companyId: string) => {
        return companyId?.toString() === "01";
    };

    isDEPCompany = (companyId: string) => {
        if (companyId?.toString()?.includes("01-001-") || companyId?.toString() == "01-001") {
            return true;
        }
        return false;
    };

    ignoreMessages = (msg: string) => {
        if (
            msg.includes("[GreetingMessage]") ||
            msg.includes("[NAVIGATEURL]") ||
            msg.includes("[TRANSFERCHAT]") ||
            msg.includes("[AutoTransfer]")
            // msg == "Please reply here" ||
            // msg == "Your patience is much appreciated. I'll be with you in a moment."
        ) {
            return true;
        } else {
            return false;
        }
    };

    getVisitorLangByChatId = (id) => {
        var visitorLangs = JSON.parse(localStorage.getItem("visitorChatLangs") as any);
        if (visitorLangs != null && visitorLangs.length > 0) {
            const chat = visitorLangs.find((item) => item.chatId == id);
            if (chat) {
                return chat.lang;
            } else {
                return "";
            }
        } else {
            return "";
        }
    };

    // getVisitorLanguage = async (chat: any) => {
    //     const find = chat.filter((item)=>{
    //         if(!item.IsSent && !this.ignoreMessages(item.messageText)){
    //             return item
    //         }
    //     })

    //     if(find != undefined && find.length>0){
    //         const length = find.length
    //         const lastMsg = find[length-1]

    //         // const language = await wglcsApiService.detectLanguage(lastMsg)
    //         // console.log(language)
    //     }

    // }

    isEaglyHillsCompany = (companyId: string) => {
        return companyId?.toString() === "01-1326";
    };

    isIronFXCompany = (companyId: string) => {
        return companyId?.toString() === "01-766";
    };

    isFerrariBeverlyHillsCompany = (companyId: string) => {
        return companyId?.toString() === "01-001-678";
    };

    removeSpecialCharacters = (input: string, replaceWith: string = ""): string => {
        return input.replace(/[^\w ]/, replaceWith);
    };

    getCurrentPathName = () => {
        return window.location.hash.substring(1);
    };

    getRunningChats = () => {
        try {
            const chats = localStorage.getItem("runningChatsCount") as any;

            if (chats === null) {
                return 0; 
            }

            const parsedChats = isNaN(chats) ? JSON.parse(chats) : Number(chats);

            return parsedChats;
        } catch (error) {
            console.error("Failed to retrieve running chats:", error);
            return 0; 
        }
    };

    getAppVisibility = () => {
        try {
            if (typeof document !== 'undefined' && typeof document.visibilityState === 'string') {
                const activeAwayStatus = document.visibilityState === "visible" ? "Active" : "Away";
                return activeAwayStatus;
            } else {
                console.warn("Visibility API not supported.");
                return "Unknown";
            }
        } catch (error) {
            console.error("Error getting app visibility:", error);
            return "Unknown";
        }
    };

    removeQuotes = (msg) => {
        var cleanMsg: any = "";
        cleanMsg = msg
            .replace(/&quot;/g, '"')
            .replace(/&apos;/g, "'")
            .replace(/&lt;/g, "<")
            .replace(/&gt;/g, ">")
            .replace(/&amp;/g, "&")
        return cleanMsg;
    };
    isElectronBuild = () => {
        if (DetectEnvironment.config.REACT_APP_TARGET_BUILD == "electron") {
            return true;
        } else {
            return false;
        }
    };

    getQueryParameters = () => {
        return new URLSearchParams(window.location.hash.slice(window.location.hash.indexOf("?")));
    };

    willContactDetailsShow = (interfaces: any) => {
        var result = interfaces?.some((x) => x.interfaceName === Interfaces.ShowContactDetails);
        return result;
    };

    isBotSuggestionAllowed = (industry: string | any): boolean => {
        try {
            const botSuggestionIndustries = ["DEP Autos", "Auto Bot 1.0", "Auto Bot 2.0"];
            var result = botSuggestionIndustries?.some((x) => x?.toLowerCase() === industry?.trim()?.toLowerCase());
            return result;
        } catch (e) {
            return false;
        }
    };

    QcChatTypeCheck = (interfaces: any[]) => {
        var TrainingScreenLite = interfaces?.some((x) => x.interfaceName === Interfaces.TrainingScreenLite);
        var TakeOverWithSpace = interfaces?.some((x) => x.interfaceName === Interfaces.TakeOverWithSpace);
        var TakeOver = interfaces?.some((x) => x.interfaceName === Interfaces.TakeOver);
        var TakeOverLite = interfaces?.some((x) => x.interfaceName === Interfaces.TakeOverLite);

        if (TrainingScreenLite && !TakeOver && !TakeOverLite && !TakeOverWithSpace) {
            return QcOperationTypeChecks.Internal;
        }

        if (TrainingScreenLite && (TakeOver || TakeOverLite || TakeOverWithSpace)) {
            return QcOperationTypeChecks.Both;
        }

        if (!TrainingScreenLite && (TakeOver || TakeOverLite || TakeOverWithSpace)) {
            return QcOperationTypeChecks.TakeOver;
        }

        return QcOperationTypeChecks.Both;
    };

    isHybridPanelAllowed = (interfaces: RoleInterface[]): boolean => {
        if (
            interfaces?.some(
                (i) =>
                    i.interfaceName === Interfaces.TrainingScreenLite ||
                    i.interfaceName === Interfaces.TakeOverWithSpace ||
                    i.interfaceName === Interfaces.TakeOver ||
                    i.interfaceName === Interfaces.TakeOverLite
            )
        ) {
            return true;
        }

        return false;
    };

    isMonitoringPanelAllowed = (interfaces: RoleInterface[]): boolean => {
        if (
            interfaces?.some((i) => i.interfaceName === Interfaces.QAScreen) &&
            interfaces?.some((i) => i.interfaceName === Interfaces.TrainingScreen)
        ) {
            return true;
        }
        return false;
    };
    isOpertorPanelAllowed = (interfaces: RoleInterface[]): boolean => {
        if (interfaces?.some((i) => i.interfaceName === Interfaces.OperatorWindow)) {
            return true;
        }
        return false;
    };
    ischatTakenOverMessageAllow = (interfaces: RoleInterface[]): boolean => {
        if (interfaces?.some((i) => i.interfaceName === Interfaces.ClientTakeover)) {
            return true;
        }
        return false;
    };

    DoesEmailAlreadyExist = (errorCode: string): boolean => {
        if (errorCode === "AP-2019-9qXWFw" || errorCode === "AP-2020-pPM8GQ") {
            return true;
        }
        return false;
    };

    isWebsiteAlreadyAssigned = (errorCode: string): boolean => {
        if (errorCode === "AP-2079-500") {
            return true;
        }
        return false;
    };

    DoesUsernameAlreadyExist = (errorCode: string): boolean => {
        if (errorCode === "AP-2019-8qXWFw") {
            return true;
        }
        return false;
    };

    DoesDomainAlreadyExist = (errorCode: string): boolean => {
        if (errorCode === "AP-2194-LYhU2s") {
            return true;
        }
        return false;
    };

    GetFRTEmailDelayColors = (key: string, value: number): string => {
        try {
            if (key === "FRT") {
                if (value < 10) {
                    return "rgb(154 240 192)";
                } else if (value < 30) {
                    return "rgb(251 181 51)";
                } else {
                    return "rgb(249 140 140)";
                }
            }

            if (key === "EmailDelay") {
                if (value < 7) {
                    return "rgb(154 240 192)";
                } else if (value < 15) {
                    return "rgb(251 181 51)";
                } else {
                    return "rgb(249 140 140)";
                }
            }

            return "#5579C8";
        }
        catch (e) {
            return "#5579C8";
        }
    };

    HasWebsiteLimitExceeded = (errorCode: string): boolean => {
        if (errorCode === "AP-2203-9vm4J7") {
            return true;
        }
        return false;
    };

    validateEmail = (email) => {
        var res = String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );

        if (res != null) {
            return true;
        }
        return false;
    };

    isAnyChatPanelActive = () => {
        if (
            this.isLoggedInResourcesScreenActive() ||
            this.isChatScreenActive() ||
            this.isMonitoringPanelScreenActive() ||
            this.isQcMasterPanelActive() ||
            this.isTestingScreenActive() ||
            this.isLoggedInResourcesChatScreenActive()
        ) {
            return true;
        }

        return false;
    };

    isHybridPanelActive = (panelType: ChatPanelTypes): boolean => {
        if (panelType === ChatPanelTypes.HybridPanel) {
            return true;
        }

        return false;
    };

    isQuickResponses = (interfaces: RoleInterface[]): boolean => {
        if (
            interfaces?.some(
                (i) =>
                    i.interfaceName === Interfaces.cannedResponses ||
                    i.interfaceName === Interfaces.personalCanned ||
                    i.interfaceName === Interfaces.pushContent
            )
        ) {
            return true;
        }

        return false;
    };

    isLoggedInResourcesActive = (panelType: ChatPanelTypes): boolean => {
        if (panelType === ChatPanelTypes.LoggedInResourcesPanel) {
            return true;
        }

        return false;
    };

    isLoggedInResourcesChatScreenActive = (): boolean => {
        var path = this.getCurrentPathName();
        if (path.includes("/logged-in-resources/")) {
            return true;
        }
        return false;
    };

    isMonitoringPanelActive = (panelType: ChatPanelTypes): boolean => {
        if (panelType === ChatPanelTypes.MonitoringPanel) {
            return true;
        }

        return false;
    };
    isQcMasterPanelActive = (): boolean => {
        var path = this.getCurrentPathName();
        if (path.includes("/Master-QC")) {
            return true;
        }
        return false;
    };

    isOperaterPanelActive = (panelType: ChatPanelTypes): boolean => {
        if (panelType === ChatPanelTypes.OperaterPanel) {
            return true;
        }

        return false;
    };

    isMonitoringPanelUserWise = (nType: MonitoringPanelTypes): boolean => {
        if (nType === MonitoringPanelTypes.UserWise) {
            return true;
        }

        return false;
    };

    isChatTranscriptActive = (): boolean => {
        var path = this.getCurrentPathName();
        if (path === "/transcript") {
            return true;
        }
        return false;
    };

    isChatScreenActive = (): boolean => {
        var path = this.getCurrentPathName();
        if (path === "/chat/:chatid" || path === "/hybridChat") {
            return true;
        }
        return false;
    };


    isHybridScreenActive = (): boolean => {
        var path = this.getCurrentPathName();
        if (path === "/hybridChat") {
            return true;
        }
        return false;
    };

    isLoggedInResourcesScreenActive = (): boolean => {
        var path = this.getCurrentPathName();
        if (path.includes("/logged-in-resources")) {
            return true;
        }
        return false;
    };

    isChatLogScreenActive = (): boolean => {
        var path = this.getCurrentPathName();
        if (path === "/Chat-Logs") {
            return true;
        }
        return false;
    };

    isTestingScreenActive = (): boolean => {
        var path = this.getCurrentPathName();
        if (path === "/testing-module") {
            return true;
        }
        return false;
    };
    isSurveyExternalWindow = (): boolean => {
        var path = this.getCurrentPathName();
        if (utils.isElectronBuild()) {
            const pathOnly = path.split("?")[0];
            if (pathOnly === "/Survey-questionwindow") {
                return true;
            }
        } else {
            if (path === "/Survey-questionwindow") {
                return true;
            }

        }
        return false;
    };

    detectHostname = () => {
        const domain = window.location.hostname;

        var selectedHost = HostingEnvironment.LiveAdmins;
        if (domain.includes("testing.thelivechatsoftware.com")) {
            selectedHost = HostingEnvironment.Development;
        } else if (domain.includes("smartchat.i1smartmarketing.com")) {
            selectedHost = HostingEnvironment.SmartMarkeeting;
        } else if (domain.includes("dashboard.dealereprocesschat.com")) {
            selectedHost = HostingEnvironment.DEP;
        } else if (domain.includes("web.liveadmins.net")) {
            selectedHost = HostingEnvironment.LiveAdmins;
        }

        return selectedHost;
    };

    isOperaterScreenActive = (): boolean => {
        var currentPath = this.getCurrentPathName();
        if (currentPath === "/chat/:chatid") {
            return true;
        }
        return false;
    };

    isChatTranscriptScreenActive = (): boolean => {
        var currentPath = this.getCurrentPathName();
        if (currentPath === "/transcript") {
            return true;
        }
        return false;
    };

    isItI1SmartMarketing = (): boolean => {
        if (DetectEnvironment.config.REACT_APP_TAB_TITLE == "i1SmartMarketing") {
            return true;
        }

        return false;
    };

    isInterChanges = (): boolean => {
        if (DetectEnvironment.config.REACT_APP_TAB_TITLE == "Interchanges") {
            return true;
        }

        return false;
    };

    isI1SmartMarketing = (): boolean => {
        if (DetectEnvironment.config.REACT_APP_TAB_TITLE == "i1SmartMarketing") {
            return true
        }

        return false;
    };

    isDepLiveChat = (): boolean => {
        if (DetectEnvironment.config.REACT_APP_TAB_TITLE == "DEP Live Chat") {
            return true
        }

        return false;
    };

    geti1SmartMarketingInventory = async () => {
        try {
            // Fetch the XML data from the URL
            const response = await fetch('https://psxdigital.com/powersports-marketing-automation/hooks/inventory/joM/photos');
            const xmlText = await response.text();

            // Parse the XML data
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(xmlText, 'text/xml');
            const unitNodes = xmlDoc.getElementsByTagName('unit');

            // Extract data from XML and transform it into JavaScript objects
            const inventoryDetails = Array.from(unitNodes).map((unitNode) => ({
                address: unitNode.getElementsByTagName('Address')[0]?.textContent,
                address2: unitNode.getElementsByTagName('Address2')[0]?.textContent,
                beam: unitNode.getElementsByTagName('Beam')[0]?.textContent,
                boatname: unitNode.getElementsByTagName('Boatname')[0]?.textContent,
                builder: unitNode.getElementsByTagName('Builder')[0]?.textContent,
                category: unitNode.getElementsByTagName('Category')[0]?.textContent,
                city: unitNode.getElementsByTagName('City')[0]?.textContent,
                classType: unitNode.getElementsByTagName('Class')[0]?.textContent, // 'class' is a reserved word in JavaScript
                condition: unitNode.getElementsByTagName('Condition')[0]?.textContent,
                color: unitNode.getElementsByTagName('Color')[0]?.textContent,
                description: unitNode.getElementsByTagName('Description')[0]?.textContent,
                draft: unitNode.getElementsByTagName('Draft')[0]?.textContent,
                headline: unitNode.getElementsByTagName('Headline')[0]?.textContent,
                height: unitNode.getElementsByTagName('Height')[0]?.textContent,
                length: unitNode.getElementsByTagName('Length')[0]?.textContent,
                make: unitNode.getElementsByTagName('Make')[0]?.textContent,
                mileage: unitNode.getElementsByTagName('Mileage')[0]?.textContent,
                model: unitNode.getElementsByTagName('Model')[0]?.textContent,
                msrp: unitNode.getElementsByTagName('Msrp')[0]?.textContent,
                price: unitNode.getElementsByTagName('Price')[0]?.textContent,
                state: unitNode.getElementsByTagName('State')[0]?.textContent,
                stocknumber: unitNode.getElementsByTagName('Stocknumber')[0]?.textContent,
                unique: unitNode.getElementsByTagName('Unique')[0]?.textContent,
                vin: unitNode.getElementsByTagName('Vin')[0]?.textContent,
                width: unitNode.getElementsByTagName('Width')[0]?.textContent,
                year: unitNode.getElementsByTagName('Year')[0]?.textContent,
                zipcode: unitNode.getElementsByTagName('Zipcode')[0]?.textContent,
                engineType: unitNode.getElementsByTagName('EngineType')[0]?.textContent,
                boreXStroke: unitNode.getElementsByTagName('BoreXStroke')[0]?.textContent,
                compressionRatio: unitNode.getElementsByTagName('CompressionRatio')[0]?.textContent,
                fuelDelivery: unitNode.getElementsByTagName('FuelDelivery')[0]?.textContent,
                transmission: unitNode.getElementsByTagName('Transmission')[0]?.textContent,
                finalDrive: unitNode.getElementsByTagName('FinalDrive')[0]?.textContent,
                frontSuspension: unitNode.getElementsByTagName('FrontSuspension')[0]?.textContent,
                rearSuspension: unitNode.getElementsByTagName('RearSuspension')[0]?.textContent,
                frontBrakes: unitNode.getElementsByTagName('FrontBrakes')[0]?.textContent,
                rearBrakes: unitNode.getElementsByTagName('RearBrakes')[0]?.textContent,
                frontTires: unitNode.getElementsByTagName('FrontTires')[0]?.textContent,
                rearTires: unitNode.getElementsByTagName('RearTires')[0]?.textContent,
                lxwxh: unitNode.getElementsByTagName('LXWXH')[0]?.textContent,
                seatHeight: unitNode.getElementsByTagName('SeatHeight')[0]?.textContent,
                wheelbase: unitNode.getElementsByTagName('Wheelbase')[0]?.textContent,
                rakeCasterAngle: unitNode.getElementsByTagName('RakeCasterAngle')[0]?.textContent,
                trail: unitNode.getElementsByTagName('Trail')[0]?.textContent,
                maximumGroundClearance: unitNode.getElementsByTagName('MaximumGroundClearance')[0]?.textContent,
                fuelCapacity: unitNode.getElementsByTagName('FuelCapacity')[0]?.textContent,
                wetWeight: unitNode.getElementsByTagName('WetWeight')[0]?.textContent,
                phone: unitNode.getElementsByTagName('Phone')[0]?.textContent,
                photos: Array.from({ length: 20 }, (_, i) => unitNode.getElementsByTagName(`Photo${i + 1}`)[0]?.textContent).filter(Boolean),
            }));

            return inventoryDetails
        } catch (error) {
            console.error('Error fetching or parsing XML:', error);
        }
    };



    isDevEnvironment = (): boolean => {
        if (DetectEnvironment.config.REACT_APP_HOST_URL == "https://testing.thelivechatsoftware.com") {
            return true;
        }

        return false;
    };

    isDepEnvironmentActive = (): boolean => {
        if (DetectEnvironment.config.REACT_APP_TAB_TITLE == "DEP Live Chat") {
            return true;
        }

        return false;
    };

    inputDirection = () => {
        var selectedlanguage = cookieService.getElectronCookies("language");
        if (selectedlanguage == "ar") {
            return "rtl";
        }

        return "ltr";
    };

    isArabicLanguage = () => {
        var userData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse;
        return userData?.userLoginData?.languageId == 5;
    };
    isChineseLanguage = () => {
        var userData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse;
        return userData?.userLoginData?.languageId == 8;
    };

    isTextToSpeechInterfaceAssigned = () => {
        let userData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse;
        let interfaceResponse = userData?.interfaces?.some((el) => el.interfaceName === "TextToSpeech");
        return interfaceResponse;
    };

    getLoggedInUserId = () => {
        var userData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse;
        return userData?.userLoginData?.empCompId;
    }

    getLanguageById = (loginResult) => {
        if (loginResult.data.userLoginData.languageId == 5) {
            return "ar";
        } else if (loginResult.data.userLoginData.languageId == 8) {
            return "ch";
        }

        return "en";
    };

    isMonitoringPanelScreenActive = (): boolean => {
        var path = this.getCurrentPathName();
        if (path === "/monitoringPanel") {
            return true;
        }

        return false;
    };
    isFaceBookChat = (nType: string) => {
        if (nType === "facebook") {
            return true;
        }

        return false;
    };

    convertStringToCapitalize = (value) => {
        if (value) {
            const convertedValue = value?.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')

            return convertedValue
        }

        return ""
    }


    isSignalRChat = (chatType) => {
        // var services: Map<string, boolean> = new Map<string, boolean>();
        // services = new Map<string, boolean>([
        //     ["Chat", false],
        //     ["web2.0", true],
        //     ["TextUs", true],
        //     ["facebook", true],
        //     ["RTC", true],
        //     ["WhatsApp", true],
        //     ["AI Open Bot", true],
        //     ["TextUsGMB", true],
        //     ["facebookBot", true],
        //     ["HybridFaceBookChat", true],
        //     ["WhatsAppBot", true],
        //     ["Hybrid Whats App Chat", true],
        // ]);

        if (chatType == "Chat") {
            return false;
        }

        return true;
    };

    isWhatsAppChat = (nType: string) => {
        if (nType === "WhatsApp") {
            return true;
        }

        return false;
    };

    isChatToSMSChat = (nType: string) => {
        if (nType === "TextUs") {
            return true;
        }

        return false;
    };

    isGoogleMyBussinessChat = (nType: string) => {
        if (nType === "TextUsGMB") {
            return true;
        }

        return false;
    };

    getGridValues = (selectedTemplate: Templates, ChatPanelType: any) => {
        if (utils.isLoggedInResourcesActive(ChatPanelType)) {
            return {
                lg: [
                    { i: "chatBox", x: 0, y: 0, w: 5.0, minW: 0, h: 3.5, isDraggable: false },
                    { i: "cannedMessage", x: 8.0, y: 0, w: 3.1, h: 3.5, isDraggable: false },
                ],
            };
        } else if (selectedTemplate == Templates.Template1) {
            return {
                lg: [
                    { i: "chatsMenu", x: 0, y: 0, w: 3, h: 3.5, isDraggable: false },
                    { i: "chatBox", x: 3, y: 0, w: 5.8, minW: 3, h: 2.3, isDraggable: false },
                    { i: "visitorInfo", x: 8.8, y: 0, w: 3.2, h: 3.5, isDraggable: false },
                    { i: "operaterMsgs", x: 3, y: 1, w: 5.8, minW: 2, h: 1.2, isDraggable: false },
                ],
            };
        } else if (selectedTemplate == Templates.Template2) {
            return {
                lg: [
                    { i: "cannedMessage", x: 0, y: 0, w: 3.1, h: 3.5, isDraggable: false },
                    { i: "chatsMenu", x: 3.1, y: 0, w: 1.3, h: 3.5, isDraggable: false },
                    { i: "chatBox", x: 4.4, y: 0, w: 3.8, minW: 3, h: 2.3, isDraggable: false },
                    { i: "personalCannedMessages", x: 8.2, y: 0, w: 2.0, minW: 3, h: 3.5, isDraggable: false },
                    { i: "visitorInfo", x: 10.2, y: 0, w: 1.8, h: 3.5, isDraggable: false },
                    { i: "operaterMsgs", x: 4.4, y: 1, w: 3.8, minW: 2, h: 1.2, isDraggable: false },
                ],
            };
        } else {
            return {
                lg: [
                    { i: "cannedMessage", x: 0, y: 0, w: 4.0, h: 3.5, isDraggable: false },
                    { i: "chatsMenu", x: 4.0, y: 0, w: 1.0, h: 3.5, isDraggable: false },
                    { i: "chatBox", x: 5.0, y: 0, w: 5.0, minW: 3, h: 3.5, isDraggable: false },
                    { i: "personalCannedMessages", x: 10.2, y: 0, w: 2.0, minW: 3, h: 3.5, isDraggable: false },
                ],
            };
        }
    };

    getCurrentTemplate = () => {
        var res = cookieService.getSettingsCookies();

        if (res == null) {
            return Templates.Template1;
        } else {
            return res?.selectedTemplate;
        }
    };

    isThisMobileDevice = () => {
        if (window.innerWidth < 550) {
            return true;
        }
        return false;
    };

    detectMobileDevice = () => {
        const userAgent = navigator?.userAgent?.toLowerCase();
        const isMobileDevice = /mobile|tablet|ip(ad|hone|od)|android/i.test(userAgent);
        return isMobileDevice;
    };

    tokenExpire = (errorCode: string): boolean => {
        // "AP-2039-401" You are not authorized to access this resource
        if (errorCode === "AP-2095-401" || errorCode === "AP-2039-401") {
            return true;
        }
        return false;
    };

    GetEmailFormURL = (companyType) => {
        var CompanyUrlMap: Map<CompanyType, string> = new Map([
            [CompanyType.LiveAdmins1, "https://email.thelivechatsoftware.com/EmailForm/Emailform.aspx?"],
            [CompanyType.LiveAdmins2, "https://email.thelivechatsoftware.com/EmailForm/default.aspx?"],
            [CompanyType.EaglyHills, "EmailForm/EmailFormEaglehills.aspx?"],
            [CompanyType.DEP, "https://email.thelivechatsoftware.com/EmailForm/EmailFormClient.aspx?"],
        ]);

        if (utils.isItI1SmartMarketing() && utils.isChatTranscriptActive()) {
            return "https://email.thelivechatsoftware.com/EmailForm/chat.aspx?"
        }

        return CompanyUrlMap.get(companyType);
    };

    openEmailForm = async (empCompId, userID, visitorId, chatID, websiteID, timeStamp, forCopy: boolean = false, isInMinimizedState = false) => {
        var companyType = await this.GetCompanyType(empCompId);

        if (companyType === CompanyType.Unknown) {
            return;
        }

        let visiterId = visitorId;
        let chatId = chatID;
        let websiteId = websiteID;
        let userId = userID;
        var startTime = moment.utc(timeStamp).format("MM/DD/YY H:mm:ss");

        var startqa = "";

        if (companyType === CompanyType.LiveAdmins1) {
            startqa = "qa=true&";
        }

        var baseURL = utils.GetEmailFormURL(companyType);

        if (startTime === null || startTime == "" || startTime == "Invalid date") {
            startTime = "01/01/2008 00:00:00";
        }

        var urlParameters = `${startqa}VisitorId=${visiterId}&ChatId=${chatId}&WebsiteId=${websiteId}&UserId=${userId}&ChatStartTime=${startTime}&EmpCompanyId=${empCompId}`;
        var generatedUrl = "";

        // if (utils.isElectronBuild()) {
        //     var log = `[${moment().format(
        //         "h:mm:ss DD/MM/YYYY"
        //     )}] ---- method: before encryption: utils.openEmailForm -----chatID: ${chatID} -----  baseUrl : ${baseURL} : Params: ${urlParameters}`;
        //     logger.saveLog(log);
        // }

        let body = {
            data: urlParameters,
        };
        let response = await wglcsApiService.doencrypt(body);
        if (response?.data?.status) {
            generatedUrl = baseURL + "ch=" + response?.data?.data;
        } else {
            logger.log("encrypt Api error status : ", response?.data?.status);
            logger.log("encrypt Api error message : ", response?.data?.msg);
        }

        if (forCopy) {
            navigator.clipboard.writeText(generatedUrl);
            return;
        }

        // if (this.isThisMobileDevice()) {
        //     const newWindow = window.open('', '_blank', 'width=600,height=400');
        //     if (newWindow) {
        //         const iframe = document.createElement('iframe');
        //         iframe.src = generatedUrl;
        //         iframe.title = 'Email Form';
        //         iframe.style.width = '100%';
        //         iframe.style.height = '100%';

        //         newWindow.document.body.appendChild(iframe);
        //     }

        //     if (window.focus() as any) (newWindow as any).focus();
        // }
        // else{

        if (utils.isElectronBuild()) {
            window?.myAPI?.OpenEmailFormCT({ generatedUrl: generatedUrl, isInMinimizedState: isInMinimizedState });
            // var log = `[${moment().format(
            //     "h:mm:ss DD/MM/YYYY"
            // )}] ---- method: after encryption: utils.openEmailForm -----chatID: ${chatId} -----  generatedUrl  : ${generatedUrl}`;
            // logger.saveLog(log);
        } else {
            const newWindow = window.open(
                generatedUrl,
                chatId,
                `scrollbars=yes,
                        width=${1000}, 
                        height=${500}, 
                        top=${120}, 
                        left=${300}
                        `
            ) as any;
            newWindow.location.reload(true);
            if (window.focus() as any) (newWindow as any).focus();
        }

        // const newWindow = window.open(
        //     generatedUrl,
        //     chatId,
        //     `scrollbars=yes,
        //             width=${1000}, 
        //             height=${500}, 
        //             top=${120}, 
        //             left=${300}
        //             `
        // ) as any;
        // newWindow.location.reload(true);
        // if (window.focus() as any) (newWindow as any).focus();
        // }
    };

    getPlainChatLink = async (empCompId, userID, visitorId, chatID, websiteID, timeStamp, forCopy: boolean = false) => {
        let companyType = await this.GetCompanyType(empCompId);

        if (companyType === CompanyType.Unknown) {
            return;
        }

        let visiterId = visitorId;
        let chatId = chatID;
        let websiteId = websiteID;
        let userId = userID;
        let startTime: any = null;
        let startqa = "";

        if (companyType === CompanyType.LiveAdmins1) {
            startqa = "qa=true&";
        }

        if ((startTime === null || startTime == "" || startTime == "Invalid date") && !this.isChatLogScreenActive()) {
            startTime = "01/01/2008 00:00:00";
        } else {
            startTime = timeStamp
        }

        let baseURL = utils.GetEmailFormURL(companyType);
        let urlParameters = `${startqa}VisitorId=${visiterId}&ChatId=${chatId}&WebsiteId=${websiteId}&UserId=${userId}&ChatStartTime=${startTime}&EmpCompanyId=${empCompId}`;
        let generatedUrl = "";

        generatedUrl = baseURL + urlParameters;

        return generatedUrl;
    };

    getChatLink = async (empCompId, userID, visitorId, chatID, websiteID, timeStamp, forCopy: boolean = false) => {
        var companyType = await this.GetCompanyType(empCompId);

        if (companyType === CompanyType.Unknown) {
            return;
        }

        let visiterId = visitorId;
        let chatId = chatID;
        let websiteId = websiteID;
        let userId = userID;
        var startTime = moment.utc(timeStamp).format("MM/DD/yy H:mm:ss");
        var startqa = "";

        if (companyType === CompanyType.LiveAdmins1) {
            startqa = "qa=true&";
        }

        var baseURL = utils.GetEmailFormURL(companyType);
        var urlParameters = `${startqa}VisitorId=${visiterId}&ChatId=${chatId}&WebsiteId=${websiteId}&UserId=${userId}&ChatStartTime=${startTime}&EmpCompanyId=${empCompId}`;
        var generatedUrl = "";

        let body = {
            data: urlParameters,
        };
        let response = await wglcsApiService.doencrypt(body);
        if (response?.data?.status) {
            generatedUrl = baseURL + "ch=" + response?.data?.data;
        }

        return generatedUrl;
    };

    getLanguageNameById = async (id: number) => {
        const response = await wglcsApiService.getempcompanylanguagesdetail();
        if (response.status === 200 && response?.data?.data.length > 0) {
            return response?.data?.data.filter((lang) => lang.languageId == id)[0];
        }
        return;
    };

    removeDuplicates = (originalArray, prop) => {
        var newArray = [] as any;
        var lookupObject = {};

        for (var i in originalArray) {
            lookupObject[originalArray[i][prop]] = originalArray[i];
        }

        for (i in lookupObject) {
            newArray.push(lookupObject[i]);
        }
        return newArray;
    };

    arraySorting = (field, data) => {
        let sorted = data.sort(function (a, b) {
            return a?.[field]?.toLowerCase()?.localeCompare(b?.[field]?.toLowerCase());
        });
        return sorted;
    };

    willMaskingApplied = (opTreeChats, websiteId, interfaces) => {
        var checkMasking = opTreeChats?.find((item) => item.id == Number(websiteId));
        var isAllowd = utils.willContactDetailsShow(interfaces);
        if (checkMasking != undefined && checkMasking?.maskingTypeID != "1" && isAllowd == false) {
            return true;
        }

        return false;
    }

    willMaskingApplyOnPhoneNumber = (user_id, managerId, _message, isSent, websiteId, opTreeChats, interfaces, chatType) => {
        if (
            chatType != "facebook.com/marketplace" &&
            user_id == "0" &&
            managerId == "0" &&
            chatType != "TextUs" &&
            chatType != "facebook" &&
            !isSent
        ) {
            var checkMasking = opTreeChats?.find((item) => item.id == Number(websiteId));
            if (
                checkMasking != undefined &&
                checkMasking?.maskingTypeID != "1" &&
                !utils.willContactDetailsShow(interfaces)
            ) {
                return true;
            }
            //  else if (message.length >= 8 && message.length <= 20) {
            //     return false;
            // }
        }
        return null;
    };

    willMaskingApplyOnEmail = (user_id, managerId, message, isSent, websiteId, opTreeChats, interfaces) => {
        if (user_id == "0" && managerId == "0" && emailRegex.test(message) && !message.includes("liveadmins.com") && !isSent) {
            var checkMasking = opTreeChats?.find((item) => item.id == Number(websiteId));
            var isAllowd = utils.willContactDetailsShow(interfaces);
            if (checkMasking != undefined && checkMasking?.maskingTypeID != "1" && isAllowd == false) {
                return true;
            } else {
                return false;
            }
        }
        return null;
    };

    convertSentenceIntoCamlCase = (name) => {
        // Split the name into an array of words
        const words = name.toLowerCase().split(" ");

        // Capitalize the first letter of each word
        const convertedName = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1));

        // Join the words back into a string
        return convertedName.join(" ");
    };

    getTimeDifference = (beforeTime, afterTime) => {
        const time1 = moment(beforeTime);
        const time2 = moment(afterTime);

        const diffMilliseconds = time2.diff(time1);

        // Convert milliseconds to seconds
        const diffSeconds = Math.floor(diffMilliseconds / 1000);

        return diffSeconds;
    };

    isQcMessage = (managerId: number, userId: number) => {
        if (managerId > 0 && userId < 0 && managerId != -1 * userId) {
            return true;
        }

        if (managerId > 0 && userId > 0 && managerId != userId) {
            return true;
        }

        return false;
    };
    isDarkMode = () => {
        let layoutMode = cookieService.getElectronCookies("LayoutMode");
        if (layoutMode?.toString() === "layout-dark") {
            return true;
        }
        return false;
    };

    loadCssIntoDom = (id: string, path: string) => {
        var existingElement = document.getElementById(id);

        if (existingElement != null) {
            return;
        }

        var link = document.createElement("link");

        link.setAttribute("id", id);
        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = process.env.PUBLIC_URL + path;
        document.head.appendChild(link);
    }

    broadcastPostMessageHandler = (broadcastName: string, flag?: string) => {
        let broadcastChannel = new BroadcastChannel(broadcastName) as any;
        if (flag === "allow-chat-tab") {
            broadcastChannel.postMessage("redirect-to-dashboad");
            window.location.reload();
        }
    };

    broadcastOnMessageHandler = (broadcastName: string, flag?: string) => {
        let broadcastChannel = new BroadcastChannel(broadcastName) as any;
        if (flag === "allow-chat-tab") {
            broadcastChannel.onmessage = (event: any) => {
                if (event.data === "redirect-to-dashboad") {
                    if (this.isElectronBuild()) {
                        window.myAPI?.getDirPath("getDirPath", (_, data) => {
                            window.location.href = data + "/dashboard";
                        });
                    } else {
                        window.location.href = "/#/dashboard";
                    }
                }
            };
        }
    };

    setVehicleOrder = (newVehicles: any, preVehicles: any) => {
        // Get unique elements in newVehicles not found in preVehicles
        const uniqueNewVehicles = newVehicles.filter((newVehicle) => !preVehicles.some((preVehicle) => this.isSameVehicle(newVehicle, preVehicle)));

        // Get common elements
        const commonVehicles = newVehicles.filter((newVehicle) => preVehicles.some((preVehicle) => this.isSameVehicle(newVehicle, preVehicle)));


        const newlyAdded = uniqueNewVehicles?.map((item) => ({ ...item, newlyAdded: true }))
        const _commonVehicles = commonVehicles?.map((item) => ({ ...item, newlyAdded: false }))

        const orderedVehicles = [...newlyAdded, ..._commonVehicles];

        return orderedVehicles;
    };

    GetUnsentChats = async () => {
        const userData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse;
        const userId = userData?.userLoginData?.userId;

        try {
            const response = await wglcsApiService.getunsentchats(userId);
            localStorage.setItem("unsentchat", (response?.data as any)?.length);

        } catch (error) {
            console.error("Failed to fetch unsent chats:", error);
        }
    };

    isSystemMessage = (message: string) => {
        if (message?.includes("[NAVIGATEURL] Visitor browsing :") ||
            message?.includes("Your patience is much appreciated.") ||
            message?.includes("[QcRatedChat]") ||
            message?.includes("[QcClosedChat]") ||
            message?.includes("Please continue the chat") ||
            message?.includes("Please follow up.") ||
            message?.includes("Please reply here") ||
            message?.includes("[TRANSFERCHAT]_Transferred By") ||
            message?.includes("[AutoTransfer]_Transferred By")) {
            return true
        }

        return false
    }
    // Function to check if two vehicles are the same based on some properties
    isSameVehicle = (vehicle1: any, vehicle2: any): boolean => {
        return (
            vehicle1.make === vehicle2.make &&
            vehicle1.model === vehicle2.model &&
            vehicle1.year === vehicle2.year
        );
    };
    getiSPY = () => {
        // Example usage
        const exampleResponse: ISpyResponseModel = {
            iSpy_identity: "9636881",
            success: true,
            dealer: "Dealer eProcess",
            site: "acura01.dealereprocess.com",
            iSpy_data: {
                new_price_range: "41045-50595",
                bodies_viewed: "Car,SUV",
                makes_viewed: "Acura,Jeep",
                models_viewed: "TLX,RDX,Renegade",
                colors_viewed: "White",
                minutes_on_site: 210,
                // vehicles: [
                //     {
                //         year: "2023",
                //         stock: "A7162",
                //         flag_active: "1",
                //         flag_certified: "0",
                //         make: "Acura",
                //         model: "TLX",
                //         trim: "Base",
                //         vin: "19UUB5F35PA002651",
                //         color: null,
                //         img: "https://cloudflareimages.dealereprocess.com/resrc/images/c_limit,fl_lossy,w_200/v1/dvp/1/6163274867/2023-Acura-TLX-Base-ID6163274867-aHR0cDovL2ltYWdlcy51bml0c2ludmVudG9yeS5jb20vdXBsb2Fkcy9waG90b3MvMC8yMDIzLTAzLTI0LzExODEyODk3LTM1NzMwNmE1OWFmMGMzNDQ5ZTA2MmVlOWZhMDM5NGIxLmpwZw==",
                //         body: "Car",
                //         price: "41045",
                //         make_id: "1",
                //         ext_color: "Si/Lunar Silver",
                //         dealer_id: "1",
                //         model_id: "2855",
                //         do_model: "TLX",
                //         site_id: "7378",
                //         site_prices: {
                //             "7378": "41045",
                //             "9560": "41045",
                //             "11651": "41045",
                //             "12561": "41045",
                //         },
                //         count: 2,
                //         n_u: "new",
                //         url: "acura01.dealereprocess.com/auto/new-2023-TLX-TLX-Base/74897426",
                //     },
                //     {
                //         year: "2023",
                //         stock: "A7225",
                //         flag_active: "1",
                //         flag_certified: "0",
                //         make: "Acura",
                //         model: "RDX",
                //         trim: "ASPEC",
                //         vin: "5J8TC2H68PL010469",
                //         color: null,
                //         img: "https://cloudflareimages.dealereprocess.com/resrc/images/c_limit,fl_lossy,w_200/v1/dvp/1/6163276862/2023-Acura-RDX-ASPEC-ID6163276862-aHR0cDovL2ltYWdlcy51bml0c2ludmVudG9yeS5jb20vdXBsb2Fkcy9waG90b3MvMC8yMDIzLTA1LTA5LzEyMzMzMTYwLWQxMjE3NDE2YTQxMDI1NzI1ZWU3MzY5YzI0NDAyMDg2LmpwZw==",
                //         body: "SUV",
                //         price: "50595",
                //         make_id: "1",
                //         ext_color: "Si/Lunar Silver",
                //         dealer_id: "1",
                //         model_id: "5",
                //         do_model: "RDX",
                //         site_id: "7378",
                //         site_prices: {
                //             "7378": "50595",
                //             "9560": "50595",
                //             "11651": "50595",
                //             "12561": "50595",
                //         },
                //         count: 3,
                //         n_u: "new",
                //         url: "acura01.dealereprocess.com/auto/new-2023-RDX-RDX-ASPEC/76252676",
                //     },
                //     {
                //         year: "2018",
                //         stock: "DP7272B",
                //         flag_active: "1",
                //         flag_certified: "0",
                //         make: "Jeep",
                //         model: "Renegade",
                //         trim: "Latitude",
                //         vin: "ZACCJABB3JPJ72451",
                //         color: "White",
                //         img: "https://cloudflareimages.dealereprocess.com/resrc/images/c_limit,fl_lossy,w_200/v1/dvp/1/7515852706/2018-Jeep-Renegade-Latitude-ID7515852706-aHR0cDovL2ltYWdlcy51bml0c2ludmVudG9yeS5jb20vdXBsb2Fkcy9waG90b3MvMC8yMDI0LTA2LTA2LzE3NTkzMDk2LTA5YjJjNjZmOGQ2MmViMjFlMDE0MDU3MGY1NDA3NDQyLmpwZw==",
                //         body: null,
                //         price: "16491",
                //         make_id: "29",
                //         ext_color: "Alpine White",
                //         dealer_id: "1",
                //         model_id: "3090",
                //         do_model: "Renegade",
                //         site_id: "7378",
                //         site_prices: {
                //             "7378": "16491",
                //             "7741": "16491",
                //             "8603": "16491",
                //             "8606": "16491",
                //             "8609": null,
                //             "8615": "16491",
                //             "8617": "16491",
                //             "9153": "16491",
                //             "9289": "16491",
                //             "9632": "20999",
                //             "9637": "4508",
                //             "9646": "16491",
                //             "9650": "16491",
                //             "9679": "16491",
                //             "9683": "20999",
                //             "9684": null,
                //             "10027": "16491",
                //             "10030": "16991",
                //             "10652": "16491",
                //             "10664": "104",
                //             "11344": null,
                //             "11346": "16491",
                //             "11394": "16491",
                //             "11651": "20999",
                //             "11663": "20999",
                //             "11668": "16491",
                //             "11684": "20999",
                //             "12156": "16491",
                //             "12383": "16491",
                //             "12561": "16491",
                //             "12568": "16491",
                //             "12585": "16491",
                //             "13165": "16491",
                //             "14537": "16491",
                //             "14646": null,
                //             "14759": null,
                //         },
                //         count: 1,
                //         n_u: "used",
                //         url: "acura01.dealereprocess.com/auto/used-2018-Renegade-Renegade-Latitude/91418167",
                //     },
                // ],
                visit_count: 1,
                last_visit: "2015-12-18  15:27:22",
                cookie_expires: "2016-06-12  16:29:03",
            },
        };

        return exampleResponse;
    };

    generateSecurePassword = (length) => {
        const upperCase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const lowerCase = 'abcdefghijklmnopqrstuvwxyz';
        const numbers = '0123456789';
        const specialChars = '!@#$%^&*()_+[]{}|;:,.<>?';

        const allCharacters = upperCase + lowerCase + numbers + specialChars;

        let password = '';

        password += upperCase.charAt(crypto.getRandomValues(new Uint32Array(1))[0] % upperCase.length);
        password += lowerCase.charAt(crypto.getRandomValues(new Uint32Array(1))[0] % lowerCase.length);
        password += numbers.charAt(crypto.getRandomValues(new Uint32Array(1))[0] % numbers.length);
        password += specialChars.charAt(crypto.getRandomValues(new Uint32Array(1))[0] % specialChars.length);

        for (let i = 4; i < length; i++) {
            const randomIndex = crypto.getRandomValues(new Uint32Array(1))[0] % allCharacters.length;
            password += allCharacters.charAt(randomIndex);
        }

        password = password.split('').sort(() => 0.5 - Math.random()).join('');

        return password;
    }
}

var utils = new Utils();

export { utils };
